module.exports = __webpack_public_path__ + "dash_20_app_assets/img/sendinvites.327c98e5.png";